import React from "react";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
              <Col lg={12}>
                <div className="text-sm-end d-none d-sm-block">
                  Copyright © {new Date().getFullYear()} Arcmedix. All rights reserved
                </div>
              </Col>
            </Row>
        </Container>
      </footer>
    </React.Fragment>

  );
};

export default Footer;